// extracted by mini-css-extract-plugin
export default {"container":"SeriesSelectValue-module__container--n5R2t","icon":"SeriesSelectValue-module__icon--NX4n+"};